export default __webpack_public_path__ + "static/media/photo-1542744095-291d1f67b221.1fe40d01.jpg";